import MetadataBase from "./MetadataBase";

export default class ElementBase extends MetadataBase{
  constructor(xml, xmlRDBNavigation) {
    super(xml, xmlRDBNavigation);
    this.children = [];
  }

  parent() {
    return null;
  }
}